//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    head() {
        return {
            title: this.$stripHtml(this.$t('view.downloads.index.title')),
            meta: [
                {hid: 'description', name: 'description', content: this.$stripHtml(this.$t('view.downloads.index.description'))},

                // hid is used as unique identifier. Do not use `vmid` for it as it will not work
                {
                    'property': 'og:title',
                    'content': this.$stripHtml(this.$t('view.downloads.index.title')),
                    'hid': 'og:title'
                },
                {
                    'property': 'og:description',
                    'content': this.$stripHtml(this.$t('view.downloads.index.description')),
                    'hid': 'og:description'
                },
                {
                    'property': 'og:image',
                    'content': this.$image.format('/views/press/downloads/spoferan-presse-multimedia-foto-video-download-bereich.jpg', {width: 1200, height: 1200}),
                    'hid': 'og:image'
                }
            ]
        }
    }
}
